import { faBug, faSpinner } from '@fortawesome/free-solid-svg-icons';
import type { PropsWithChildren, ReactNode } from 'react';
import { Icon } from './Icon';
import styles from './Spinner.module.scss';

interface SpinnerProps extends PropsWithChildren {
	size?: 'xs' | 'sm' | 'lg' | '4x' | '1x' | '2x' | '3x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x' | undefined;
	message?: string;
}

export function Spinner(props: SpinnerProps): ReactNode {
	const size = props.size || 'lg';
	const title = props.message || 'Loading...';

	return <Icon className={styles['centeredIcon']} icon={faSpinner} spin={true} title={title} size={size} />;
}

export function LoadingError(props: SpinnerProps): ReactNode {
	const size = props.size || '2x';

	// TODO: add tooltip with more details about the error

	return <Icon className={styles['centeredIcon']} icon={faBug} title="Error loading data" size={size} />;
}
